var validateService = angular.module('eficienciaFiscalModule');

validateService.service('validateService', ['$compile', '$timeout', function ($compile, $timeout) {

    this.validate = function (scope, form) {

        var valid = true;

        var regrasValidacao = [
            {nome: "required", text: '"Este campo é obrigatório."'},
            {nome: "minlength", text: '"Este campo precisa ter " + $(field).attr("ng-minlength") + " caracteres no minimo."'},
            {nome: "maxlength", text: '"Este campo pode ter " + $(field).attr("ng-maxlength") + " caracteres no máximo."'},
            {nome: "min", text: '"O valor mínimo para este campo é " + $(field).attr("min") + "."'},
            {nome: "max", text: '"O valor máximo para este campo é " + $(field).attr("max") + "."'},
            {nome: "moneymin", text: '"Este campo precisa ser maior que " + $(field).attr("money-min")'},
            {nome: "moneymax", text: '"Este campo precisa ser menor que " + $(field).attr("money-max")'},
            {nome: "percentmin", text: '"Este campo precisa ser maior que " + $(field).attr("percent-min")'},
            {nome: "percentmax", text: '"Este campo precisa ser menor que " + $(field).attr("percent-max")'},
            {nome: "url", text: '"Este campo precisa ter uma url válida."'},
            {nome: "email", text: '"Este campo precisa ter um email válido."'},
            {nome: "number", text: '"Este campo precisa ter um número."'},
            {nome: "integer", text: '"Este campo precisa ter um inteiro válido."'},
            {nome: "date", text: '"Este campo precisa ter uma data válida."'},
            {nome: "currency", text: '"Este campo precisa ter um valor monetário válido."'},
            {nome: "pattern", text: '$(field).attr("data-error") || "Campo inválido."'},
            {nome: "percent", text: '"Campo inválido."'}
        ];

        if (typeof form == 'string')
            form = $('#' + form);

        form.find(":input").each(function () {

            var errors = [];

            var field = $(this);

            if ($(field).hasClass('ng-invalid')) {
                $(field).parents("label").addClass("state-error");
                valid = false;
            } else
                $(field).parents("label").removeClass("state-error");

            for ($i = 0; $i < regrasValidacao.length; $i++) {
                if ($(field).hasClass('ng-invalid-' + regrasValidacao[$i].nome))
                    if ($.inArray($i, errors) < 0)
                        errors.push($i);

                if ($(field).hasClass('ng-valid-' + regrasValidacao[$i].nome))
                    if ($.inArray($i, errors) >= 0)
                        errors.splice(errors.indexOf($i), 1);
            }

            if (errors.length > 0) {

                var tooltip = "",
                    position = $(field).attr('data-position') || "bottom";

                $.each(errors, function (index, value) {

                    if (index !== 0) {
                        tooltip += "";
                    }

                    tooltip += "<p class='no-margin-bottom' id='" + regrasValidacao[value].nome + "'>" + eval(regrasValidacao[value].text) + "</p>";
                });
                
                $(field).parents("label").tooltip("destroy");

                $(field).parents("label").tooltip({
                    animation: "fade",
                    html: true,
                    title: tooltip,
                    trigger: "hover focus",
                    placement: position
                });

                $(field).parents("label").tooltip("show");

                $timeout(function () {
                    $(field).parents("label").tooltip("hide");
                }, 2000);

            } else {
                $(field).parents("label").tooltip("destroy");
            }

        });

        return valid;
    };

}]);
